<div style="display: flex; justify-content: space-between">
    <div class="current-transaction-label d-flex gap-2">
        <div [style]="{ marginTop: '-0.5rem' }">
            Demande {{ currentData.operation }}
        </div>
        <div [style]="{ marginTop: '-1rem' }" class="current_values">
            [{{ currentData.reference }}]
        </div>
        <div [style]="{ marginTop: '-0.5rem' }"></div>
    </div>
    <div [style]="{ marginTop: '-1rem' }">
        <p-button
            label="Fermer"
            styleClass="p-button-danger"
            (click)="close()"
        ></p-button>
    </div>
</div>
<div class="row filter_wrapper">
    <div class="col-md-2">
        <div class="form-group">
            <label>
                <b>N° Dossier</b>
            </label>
            <input
                placeholder="Demande"
                [(ngModel)]="selectedTransaction"
                type="text"
                pInputText
            />
        </div>
    </div>
    <div class="col-md-2">
        <div class="form-group">
            <label>
                <b>IMSI</b>
            </label>
            <input
                placeholder="IMSI"
                [(ngModel)]="selectedimsi"
                type="text"
                pInputText
            />
        </div>
    </div>
    <div class="col-md-2">
        <div class="form-group">
            <label>
                <b>MSISDN</b>
            </label>
            <input
                placeholder="MSISDN"
                [(ngModel)]="selectedSim"
                type="text"
                pInputText
            />
        </div>
    </div>
    <div class="col-md-2">
        <div class="form-group">
            <label>
                <b>Statut</b>
            </label>
            <p-dropdown
                [options]="listStatuts"
                [showClear]="true"
                (onChange)="OnChangeStatut($event)"
                [(ngModel)]="selectedStatut"
                placeholder="Statut"
            >
                <ng-template let-data pTemplate="item">
                    <div class="country-item">
                        <div>
                            {{ data | titlecase }}
                        </div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
    <div class="col-md-2">
        <div class="form-group">
            <label>
                <b>Traitement</b>
            </label>
            <p-dropdown
                [options]="listTraitementTransactions"
                [showClear]="true"
                [(ngModel)]="selectedTraitement"
                placeholder="Traitement"
            >
                <ng-template let-data pTemplate="item">
                    <div class="country-item">
                        <div>
                            {{ data | titlecase }}
                        </div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
    <div class="p-0" [ngStyle]="{ width: '4rem' }" *ngIf="!secondFilter">
        <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
        <p-button
            styleClass="p-button-success"
            icon="pi pi-filter"
            (click)="onFilter()"
            [disabled]="isFilter()"
        ></p-button>
    </div>
    <div class="p-0" [ngStyle]="{ width: '4rem' }">
        <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
        <p-button
            *ngIf="!secondFilter"
            (click)="showSecondFilter()"
            styleClass="p-button-dark"
            icon="pi pi-plus"
        ></p-button>
        <p-button
            *ngIf="secondFilter"
            (click)="showSecondFilter()"
            styleClass="p-button-dark"
            icon="pi pi-minus"
        ></p-button>
    </div>
</div>
<!--------------------Second-------------Filter--------->
<div
    class="row filter_wrapper"
    style="padding-top: 0.7rem"
    *ngIf="secondFilter"
>
    <div class="col-md-2">
        <label class="block"><b>Date début</b></label>
        <p-calendar
            [(ngModel)]="filterDateStart"
            [showIcon]="true"
            (ngModelChange)="changeDateStart($event)"
            dateFormat="dd-mm-yy"
            [showButtonBar]="true"
        ></p-calendar>
    </div>
    <div class="col-md-2">
        <label class="block"><b>Date fin </b></label>
        <p-calendar
            [(ngModel)]="filterDateEnd"
            [showIcon]="true"
            [showClear]="true"
            (ngModelChange)="changeDateEnd($event)"
            dateFormat="dd-mm-yy"
            [showButtonBar]="true"
        ></p-calendar>
    </div>
    <div class="p-0" [ngStyle]="{ width: '4rem' }">
        <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
        <p-button
            styleClass="p-button-success"
            icon="pi pi-filter"
            (click)="onFilter()"
            [disabled]="isFilter()"
        ></p-button>
    </div>
</div>

<hr />
<div class="table_content_wrapper">
    <div class="table_actions_wrapper pt-2">
        <button
            pButton
            pRipple
            label="Rafraîchir"
            (click)="OnRefresh()"
            icon="pi pi-refresh"
            class="p-button-secondary"
        ></button>
        <button
            pButton
            pRipple
            label="Exporter"
            (click)="OnExportExcel()"
            icon="pi pi-download"
            [disabled]="disableAction()"
            class="p-button-helf"
        ></button>
    </div>
    <div class="d-flex gap-3">
        <app-table-header
            [count]="listTransactions"
            [legende]="getTitleForm(currentData?.type)"
            [page]="page"
            [totalPage]="totalPage"
        ></app-table-header>
        <div class="table_header__input"></div>
    </div>
    <table [ngClass]="['native_table table']">
        <thead>
            <th class="text-center">#</th>
            <th>Date Demande</th>
            <th class="text-center" [style]="{ width: '10rem' }">N° Dossier</th>
            <th class="text-center">Date MAJ</th>
            <th class="text-center">IMSI</th>
            <th class="text-center">MSISDN</th>
            <th class="text-center" [style]="{ width: '4rem' }">Statut</th>
            <th class="text-center">Traitement</th>
            <th class="text-center" [style]="{ width: '3rem' }">Actions</th>
        </thead>
        <tbody>
            <tr
                *ngFor="
                    let data of listTransactions
                        | paginate
                            : {
                                  itemsPerPage: recordsPerPage,
                                  currentPage: p,
                                  totalPages: totalPage,
                                  totalItems: totalRecords
                              };
                    let i = index
                "
            >
                <td>{{ this.offset + i }}</td>
                <td style="text-align: left">{{ data?.created_at }}</td>
                <td
                    (click)="copyData(data.transaction)"
                    style="cursor: pointer"
                >
                    {{ data?.transaction }}
                </td>
                <td>{{ data?.current_date }}</td>
                <td>
                    <span
                        (click)="data?.imsi ? copyData(data.imsi) : null"
                        style="cursor: pointer"
                        >{{ data?.imsi ?? 'N/A' }}</span
                    >
                </td>
                <td>
                    <span
                        (click)="data?.msisdn ? copyData(data.msisdn) : null"
                        style="cursor: pointer"
                        >{{ data?.msisdn ?? 'N/A' }}</span
                    >
                </td>
                <td class="text-center">
                    <span
                        [ngStyle]="{ 'font-size': '16px' }"
                        class="badge"
                        [class.badge-dark]="data?.statut === stateSoumis"
                        [class.badge-info]="data?.statut === stateTraite"
                        [class.badge-success]="data?.statut === stateCloture"
                    >
                        {{ data.statut }}
                    </span>
                </td>
                <td>
                    <span
                        [ngStyle]="{ 'font-size': '16px' }"
                        class="badge"
                        [class.badge-dark]="
                            data?.traitement === treatmenEntente ||
                            data?.traitement === treatmenAcquiter
                        "
                        [class.badge-danger]="
                            data?.traitement === treatmenRejeter ||
                            data?.traitement === treatmenRefuser
                        "
                        [class.badge-warning]="
                            data?.traitement === treatmenCancel
                        "
                        [class.badge-info]="
                            data?.traitement === treatmenAccepter
                        "
                        [class.badge-success]="
                            data?.statut === stateCloture &&
                            data?.traitement === treatmenAccepter
                        "
                    >
                        {{ data.traitement }}
                    </span>
                </td>
                <td class="td-actions">
                    <button
                        pButton
                        icon="pi pi-eye"
                        pTooltip="Voir"
                        tooltipPosition="top"
                        (click)="OnShowTraitement(data)"
                        class="p-button-dark"
                    ></button>
                    <button
                        pButton
                        icon="pi pi-book"
                        pTooltip="Journal"
                        tooltipPosition="top"
                        (click)="showJournal(data)"
                        class="p-button-primary"
                    ></button>
                </td>
            </tr>
        </tbody>
    </table>
    <div [ngClass]="['pagination-controls']">
        <pagination-controls
            (pageChange)="onPageChange($event)"
            previousLabel=""
            nextLabel=""
        >
        </pagination-controls>
    </div>
</div>
